import { render } from "./Calendar_calls.vue?vue&type=template&id=6a0e8bea&scoped=true"
import script from "./Calendar_calls.vue?vue&type=script&lang=js"
export * from "./Calendar_calls.vue?vue&type=script&lang=js"

import "./Calendar_calls.vue?vue&type=style&index=0&id=6a0e8bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0e8bea"]])

export default __exports__